






















































































import Vue from 'vue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import GridInput from '@/components/Form/GridInput.vue';

export default Vue.extend({
    name: 'BaseInputGroup',
    components: {
        GridInput,
        DatePicker,
    },
    props: {
        /** Значение ввода */
        modelValue: {
            type: [
                String,
                Number,
                Boolean,
                Array,
                Object,
                Date,
                Function,
                Symbol
            ],
            required: true,
        },
        /** Тип группы ввода */
        inputType: {
            type: String,
            required: true,
            default: 'input',
        },
        /** Подтип группы ввода (к примеру password для input) */
        additionalType: {
            type: String,
            required: false,
        },
        /** Префикс для синтеза уникальных id */
        idPrefix: {
            type: String,
            required: true,
        },
        /** Текст для подписи */
        labelText: {
            type: String,
            required: true,
        },
        /** "дежурный" текст для полей ввода */
        placeholder: {
            type: String,
            required: false,
        },
        /** Состояние валидации */
        state: {
            type: Boolean,
            required: false,
            default: true,
        },
        /** Текст при ошибке валидации */
        errorText: {
            type: String,
            required: false,
        },
        /** Значение для флажка (если активный) */
        checkedValue: {
            type: [
                String,
                Number,
                Boolean,
                Array,
                Object,
                Date,
                Function,
                Symbol
            ],
            required: false,
            default: true,
        },
        /** Значение для флажка (если отключен) */
        uncheckedValue: {
            type: [
                String,
                Number,
                Boolean,
                Array,
                Object,
                Date,
                Function,
                Symbol
            ],
            required: false,
            default: false,
        },
        /** Количество строк для textarea */
        textareaRows: {
            type: Number,
            required: false,
            default: 3,
        },
        /** настройки полей для таблицы (для грид-групп) */
        gridFields: {
            type: Array,
            required: false,
        },
        /** первичный ключ сущностей (для грид-групп) */
        primaryKey: {
            type: String,
            required: false,
        },
        /** набор данных (для грид-групп) */
        dataSet: {
            type: Array,
            required: false,
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input'
    },
    computed: {
        groupId(): string {
            return this.idPrefix + '-group';
        },
        inputId(): string {
            return this.idPrefix + '-input';
        },
        inputTag(): string {
            switch (this.inputType) {
                case 'input':
                    return 'b-form-input';
                case 'checkbox':
                    return 'b-form-checkbox';
                case 'textarea':
                    return 'b-form-textarea';
                default:
                    return 'b-form-input';
            }
        },
        simpleTemplate(): boolean {
            return (
                this.inputType === 'input' ||
                this.inputType === 'checkbox' ||
                this.inputType === 'textarea' ||
                this.inputType === undefined
            );
        },
        gridTemplate(): boolean {
            return this.inputType === 'grid';
        },
        datepickerTemplate(): boolean {
            return this.inputType === 'datetime';
        },
    },
    methods: {
        inputHandler(): void {
            this.$emit('input', this.modelValue);
        },
        getDateByStr(dateStr: string | undefined) {
            if (dateStr !== undefined) {
                return new Date(dateStr);
            }
            return new Date();
        },
    },
});
